export default "__VITE_ASSET__vR9DwPX7__"